import React from "react"
import type { FC } from "react"
import { Outlet } from "react-router"

import { UnauthenticatedAppHeader } from "@/components/unauthenticatedAppHeader/unauthenticatedAppHeader"

import { Box } from "@mui/material"

export const UnauthenticatedRoute: FC = () => {
  return (
    <>
      <UnauthenticatedAppHeader />
      <Box component="main" sx={{ mx: 2 }}>
        <Box
          sx={{
            mb: 8,
            maxWidth: 728,
            mx: "auto",
            py: 9,
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </>
  )
}
